var React = require('react');

function PlayVideoInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"},React.createElement("path",{"d":"M23.14,10.608,2.253.164A1.559,1.559,0,0,0,0,1.557V22.444a1.558,1.558,0,0,0,2.253,1.392L23.14,13.393A1.557,1.557,0,0,0,23.14,10.608Z","fill":"#000000","stroke":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"0"})));
}

PlayVideoInline.defaultProps = {"version":"1.1","xmlnssvgjs":"http://svgjs.com/svgjs","viewBox":"0 0 140 140"};

module.exports = PlayVideoInline;

PlayVideoInline.default = PlayVideoInline;
